import axios from "axios";
import { authService } from "../service/authService";

const httpClient = axios.create({
  baseURL: "i4y-tst-fcetakgqfjhrd3be.westeurope-01.azurewebsites.net",
});

httpClient.interceptors.request.use(function (config) {
  config.headers.Authorization = `Bearer ${authService.tokenValue}`;
  return config;
});

// httpClient.interceptors.response.use(null, (error) => {
//   if (error.config && error.response && error.response.status === 401) {
//     authService.refreshAccessToken().then((res) => {
//       error.config.headers.Authorization = `Bearer ${authService.tokenValue}`;
//       return axios.request(error.config);
//     });
//   }
//   return Promise.reject(error);
// });

export default httpClient;
